export enum ForwardBackward {
  forward = 'forward',
  backward = 'backward',
  // Unlike undefined, used to tell an API to take an initial action
  initial = 'initial',
}
